<div class="padding">
  <div>
    <div class="header">{{ 'create_class' | translate }}</div>
  </div>
  <div>
    <mat-icon class="close-icon" (click)="close()">close</mat-icon>
  </div>

  <form (ngSubmit)="create()" #form="ngForm" novalidate>
    <div class="flexColumn">

      <app-dataset-selector-input-async 
        (selected)="datasetChanged($event)" 
        (cleared)="datasetCleared()">
      </app-dataset-selector-input-async>

      <mat-form-field appearance="fill">
        <mat-label>{{ 'class_name' | translate }}</mat-label>
        <input type="text" name="name" matInput #name="ngModel" placeholder="Class name" required
          [(ngModel)]="class.name" pattern="^[\sa-zA-Z0-9\(\)_\-]+$" minlength="5" maxlength="30">
        <mat-hint>Minimum characters 5, {{class.name == null ? 0 : class.name?.length}}/30 Characters</mat-hint>
        <mat-error *ngIf="name.hasError('required')">{{ 'name_required' | translate }}</mat-error>
        <mat-error *ngIf="name.hasError('notUnique')">{{ 'className_exists' | translate }}</mat-error>
        <mat-error *ngIf="name.hasError('minlength')">{{ 'className_minLength' | translate }}</mat-error>
        <mat-error *ngIf="name.hasError('pattern')">{{ 'characters_allowed' | translate }}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>{{ 'description' | translate }}</mat-label>
        <textarea rows="3" name="description" matInput #description="ngModel" placeholder="Class description" required
          [(ngModel)]="class.description" maxlength="1024">
          </textarea>
        <mat-hint>{{class.description == null ? 0 : class.description?.length}}/1024 Characters</mat-hint>
      </mat-form-field>

      <div *ngIf="servicesLength !== 0">
        <mat-label>{{ 'select_services' | translate }}</mat-label>
        <mat-table matSort *ngIf="media.isActive('lg') || media.isActive('xl')" #table [dataSource]="dataSource">
      
          <!-- Checkbox Column -->
          <ng-container matColumnDef="select">
            <mat-header-cell fxFlex="15%" *matHeaderCellDef>
            </mat-header-cell>
            <mat-cell fxFlex="15%" *matCellDef="let row">
              <mat-checkbox (click)="$event.stopPropagation()"
                            [disabled]="isCheckBoxView(row)"
                            (change)="$event ? selection.toggle(row) : null"
                            [checked]="selection.isSelected(row)">
              </mat-checkbox>
            </mat-cell>
          </ng-container>
      
          <!-- Service Name Column -->
          <ng-container cdkColumnDef="service_name">
            <mat-header-cell fxFlex="85%" *cdkHeaderCellDef mat-sort-header> {{ 'service_name' | translate }} </mat-header-cell>
            <mat-cell fxFlex="85%" *cdkCellDef="let service"> {{service.name}} </mat-cell>
          </ng-container>
        
          <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
          <mat-row *cdkRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
      </div>

      <div class="saveRow">
        <a type="button" mat-raised-button (click)="cancel()">Cancel</a>
        <button type="submit" mat-raised-button color="primary" [disabled]="form.invalid">Save</button>
      </div>

    </div>
  </form>

</div>